// extracted by mini-css-extract-plugin
export default {"mobileLayout":"style_mobileLayout__mqI6F"};